import { createAsyncAtom } from '../../lib';

const walletConnectedAtom = createAsyncAtom<boolean | null>(async () => null);

export default walletConnectedAtom;
